var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14.348 12.934",
      },
    },
    [
      _c("defs"),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Group_1407",
            "data-name": "Group 1407",
            transform: "translate(-488.113 -257.984)",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "arrow-right",
                transform: "translate(480.212 253.438)",
              },
            },
            [
              _c("path", {
                staticClass: "cls-1",
                attrs: {
                  id: "Path_131",
                  "data-name": "Path 131",
                  d: "M5.912,0h11.7",
                  transform: "translate(2.989 11.014)",
                },
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "cls-2",
                attrs: {
                  id: "Path_130",
                  "data-name": "Path 130",
                  d: "M12,5l5.467,5.467L12,15.933",
                  transform: "translate(3.78 0.547)",
                },
              }),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/ArrowIcon.vue